import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/agencia`;

export const buscarAgencias = () => {
	return api.get(BASE_URL);
};

export const buscarAgenciasPaginado = (params, filtros) => {
	return api.get(`${BASE_URL}/paginado`, { params: { ...params, ...filtros } });
};

export const buscarAgenciasUsuario = () => {
	return api.get(`${BASE_URL}/agencias-usuario-logado`);
};

export const cadastrarAgencia = (data) => {
	return api.post(`${BASE_URL}`, data);
};

export const editarAgencia = (id, data) => {
	return api.put(`${BASE_URL}/${id}`, data);
};

export const buscarAgenciaPorId = (id) => {
	return api.get(`${BASE_URL}/${id}`);
};

export const deletarAgencia = (id) => {
	return api.delete(`${BASE_URL}/${id}`);
};